module.exports = __webpack_public_path__ + "img/coffee-pot.bfe1689b.svg";